import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel';
import { PositionConfig } from 'devextreme/animation/position';
import { DashCardMenuComponent } from '../card-menu/dash-card-menu.component';
@Component({
  selector: 'dk-card-analytics',
  templateUrl: './card-analytics.component.html',
  styleUrls: ['./card-analytics.component.scss'],
  standalone: true,
  imports: [DxLoadPanelModule, DashCardMenuComponent, CommonModule],
})
export class CardAnalyticsComponent {
  @Input() titleText: string;

  @Input() contentClass: string;

  @Input() isMenuVisible = true;

  @Input() isLoading = false;
  menuItems: Array<{ text: string }> = [
    { text: 'Yapılandır' },
    { text: 'Sil' },
  ];

  position: PositionConfig;
}
